export const round2 = (num?: number) =>
    num === null || num === undefined
        ? num
        : Math.round((num + Number.EPSILON) * 100) / 100;
